// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8p-3";
export var contentContainer = "_8p-0";
export var editorContainer = "_8p-1";
export var quillInputForm = "_8p-2";
export var zoneDivider = "_8p-4";